import { render, staticRenderFns } from "./DeleteProfileModal.vue?vue&type=template&id=65270d58&scoped=true"
import script from "./DeleteProfileModal.vue?vue&type=script&lang=ts"
export * from "./DeleteProfileModal.vue?vue&type=script&lang=ts"
import style0 from "./DeleteProfileModal.vue?vue&type=style&index=0&id=65270d58&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65270d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65270d58')) {
      api.createRecord('65270d58', component.options)
    } else {
      api.reload('65270d58', component.options)
    }
    module.hot.accept("./DeleteProfileModal.vue?vue&type=template&id=65270d58&scoped=true", function () {
      api.rerender('65270d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/DeleteProfileModal.vue"
export default component.exports